<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS(volatile)">
    <template v-if="!readOnly">
      <div class="r_field">
        <span class="q-field__label r_title">{{ getTitle() }}</span>
        <span class="r_value" v-html="value"/>
      </div>
      <span class="r_error" v-if="formProperty.errorFetchingData!='' || formProperty.ticketCountMode!=2">{{ formProperty.errorMsg }}</span>
    </template>
    <div v-else class="roRow">
      <span class="roLabel" v-html="getTitle() + ':'"></span>
      <span class="roValue" v-html="value"></span>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {requiredIf} from '@vuelidate/validators'
import {fldComponentsMixin} from './mixins/fldComponent'
import {StaticData} from 'src/classes/StaticData'

export default {
  mixins: [fldComponentsMixin],
  props: [
    'formProperty',
    'queryID',
    'volatile',
    'readOnly'
  ],
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      StaticData,
      value: this.getValue()
    }
  },
  validations() {
    return this.getValidations()
  },
  methods: {
    getValidations() {
      let result = {value: {}}

      result.value['requiredIf'] = requiredIf(() => {
        if (this.formProperty.masterPropertyMode == StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
          return (this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY) && this.formProperty.showThroughDependency == true
        } else {
          return this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY
        }
      })

      return result
    },
    getValue() {
      let result = this.formProperty.defaultValue
      if (this.formProperty.value) {
        result = this.formProperty.value
      }

      this.formProperty.value = result
      // let result = this.formProperty.value

      if (!result) {
        result = this.formProperty.ticketNextValue
        this.formProperty.value = this.formProperty.ticketNextValue
      }
      return result
    }
  },
  mounted() {
    this.formProperty.validate = () => {
      this.v$.$reset()
      this.v$.$touch()
      this.formProperty.invalid = this.v$.value.$error
      if (this.formProperty.errorFetchingData != "") {
        this.formProperty.errorMsg = this.formProperty.errorFetchingData
        this.formProperty.invalid = true
      }
    }

    this.formProperty.setValid = () => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // bug? - rerender field & errorstats
      this.formProperty.errorMsg = ""
      this.formProperty.invalid = false
      this.v$.$reset()
    }

    this.formProperty.setError = (errMsg) => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // bug? - rerender field & errorstats
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
      this.v$.$touch()
    }

    // Initial error? This can be if the field has SQL enabled content...
    if (this.formProperty.errorFetchingData && this.formProperty.errorFetchingData != "") {
      this.formProperty.setError(this.formProperty.errorFetchingData)
    }
    if (this.formProperty.ticketCountMode != 2) {
      this.formProperty.setError('Achtung: nur Zählmodus "beim Abschicken" wird unterstützt')
    }

    // send the initial value (stored, default or next-number preview) to the formular like the other field
    // components do (e.g. fldString) - triggers master property logic and, with instantRefresh, the refresh of
    // SQL dependent fields; on new instances only
    if (!this.formProperty.noInitOnChange && !this.formProperty.objInstanceID) {
      this.$emit('onChange', {
        classID: this.formProperty.classID,
        parentClassID: this.formProperty.parentFormPointer?.classID,
        nativename: this.formProperty.nativename,
        deleteDependentFields: false,
        value: this.value
      })
    }
  }
}
</script>

<style lang="sass">
.q-field-label
  font-weight: bold

.r_field
  padding: 5px

  .r_title
    font-size: 12px
    display: block

  .r_error
    color: var(--q-color-negative)
    font-size: 12px
    line-height: 1
</style>
